var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"block"},[_c('div',{staticClass:"block-header"},[_c('div',{staticClass:"block-title"},[(!_vm.$slots.title)?_c('span',[_vm._v(_vm._s(_vm.title))]):_vm._t("title")],2),_c('div',{staticClass:"block-actions"},[_vm._t("actions")],2)]),_c('div',{staticClass:"block-body",staticStyle:{"position":"relative"}},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }